import { generatePath } from './generate-path';
// Use this to directly generate a hash for any route that exists in the config
export const generateHash = (...args) => `#${generatePath(args)}`;
